import { cn } from '@/lib/utils';
import { parsePbts } from '@/utils/pbts';
import { PbtsTagChipDisplay } from '@/components/pbts/PbtsTagList';

type PbtsTagChipsVariant = 'dark' | 'light';

type PbtsTagChipsProps = {
	value?: string | null;
	variant?: PbtsTagChipsVariant;
	className?: string;
};

const PbtsTagChips = ({
	value,
	variant = 'dark',
	className,
}: PbtsTagChipsProps) => {
	const parsed = parsePbts(value);
	if (!parsed.valid || parsed.tags.length === 0) return null;

	return (
		<div className={cn('flex flex-wrap gap-1.5', className)}>
			{parsed.tags.map((tag, index) => (
				<PbtsTagChipDisplay
					key={`${tag.label}-${tag.direction}-${tag.polarity}-${index}`}
					tag={tag}
					variant={variant}
				/>
			))}
		</div>
	);
};

export { PbtsTagChips };
